<script setup lang="ts">
import DRResponsiveBtn from "@/components/UI/DRResponsiveBtn.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";

import { useCreateProject } from "@/stores/queries";
import EditProjectModal from "@/components/projects/EditProjectModal.vue";
import { ProjectStatus } from "@/types";

const props = withDefaults(
  defineProps<{
    type?: "link" | "responsive";
    status?: ProjectStatus;
  }>(),
  {
    status: ProjectStatus.READY,
    type: "responsive",
  }
);

const { mutateAsync: mutateCreateProject, isPending } = useCreateProject();
const router = useRouter();

const creatingProject = ref(false);
const createProject = async (payload: { name: string; color: string }) => {
  mutateCreateProject(
    {
      status: props.status,
      tags: [],
      ...payload,
    },
    {
      onSuccess: ({ id }) => {
        creatingProject.value = false;
        router.push({ name: "project", params: { id } });
      },
      onError: (error) => {
        console.error("Error creating project:", error);
      },
    }
  );
};
</script>

<template>
  <DRResponsiveBtn
    v-if="type === 'responsive'"
    class="dr-input"
    variant="primary"
    icon="bi-plus-lg"
    :label="$t('dashboard:projects.create-new-project-btn')"
    @click="creatingProject = true"
  />
  <a
    v-if="type === 'link'"
    @click="creatingProject = true"
    class="underline text-primary cursor-pointer"
  >
    {{ $t("dashboard:projects.create-new-project-btn") }}
  </a>
  <EditProjectModal
    v-model="creatingProject"
    :loading="isPending"
    @confirm="createProject"
  />
</template>

<style lang="scss" scoped></style>
